import Vue from 'vue'
import './core/plugins/base'
import './core/plugins/meta'
import App from './App.vue'
import router from './core/router'
import store from './core/store'
import vuetify from './core/plugins/vuetify'
import firebase from "firebase/app";
import BootstrapVue from 'bootstrap-vue';
import Vuelidate from 'vuelidate';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './core/config/firebase'
import VueResize from 'vue-resize'

Vue.config.productionTip = false;

Vue.use(Vuelidate);
Vue.use(BootstrapVue);
Vue.use(VueResize);


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  created () {
    const initializeAuth = new Promise((resolve) => {
      firebase.auth().onAuthStateChanged(async (user) =>  {
        await this.$store.dispatch('user/loadUserProfile', user);
      })
    });

    this.$store.commit('user/SET_AUTH_PROMISE', initializeAuth);
  }
}).$mount('#app')
